import { SysInfoSection } from "components/SysInfo/SysInfoSection";
import useDumbPageTitle from "hooks/useDumbPageTitle";

export function SysInfoPage(): JSX.Element {
  useDumbPageTitle("Sys Info");
  return <SysInfoSection />;
}
